module.exports = __webpack_public_path__ + "img/staff-title.8e2be24d.png";